/*
 * Abed Ali 27/04/2022
 * This is test only - similar filemust be updated on cloud functions
*/
import { db } from '../firebase'

let ReportFilters = {
  ReportKey: '',
  Method: '',
  Format: 'XML', // JSON or XML
  DealerKey: '',
  CustomerKey: '',
  SiteKey: '',
  FromDate: '',
  ToDate: '',
  Table: ''
}

export const Test = function () {
  console.log('Test Started ...')
  let ReportKey = 'rptDetailedUsage'
  ReportKey = '999'
  /*
  let result = GetReportSettings(ReportKey)
  console.log('ReportSettings : ')
  console.log(result)
  */
  ReportFilters.ReportKey = ReportKey
  ReportFilters.DealerKey = 'xeAsdSOOiqYM5sOZSh2zI6KHwGw1'
  const rptFiltersStr = JSON.stringify(ReportFilters)
  RunReport(rptFiltersStr).then((resultRP) => {
    console.log('Test.resultRP = ')
    console.log(resultRP)
  }).catch((err) => catchError(919, 'Test.RunReport', err.message))
}

export const GetReportSettings = function (ReportKey) {
  console.log('GetReportSettings Started ...')
  try {
    let reportKey = ReportKey
    console.log('reportKey = ' + reportKey)
    // let app = admin.app()
    // let db = app.database('https://printers-db-b4bde.firebaseio.com')
    return GetReportByKey(reportKey).then((result) => {
      console.log(result)
      console.log('result = ' + JSON.stringify(result))
      return (result)
    }).catch((err) => catchError(910, 'GetReportByKey', err.message))
  } catch (err) {
    console.log('GetReportSettings Error: ' + err.message)
    return ({ Code: 996, Message: 'GetReportSettings Error: ' + err.message })
  }
}

export const RunReport = function (ReportFilters) {
  console.log('RunReport Started ...')
  try {
    const rptFiltersStr = ReportFilters
    console.log('rptFilters = ' + rptFiltersStr)

    let resultValidate = ValidateParams(rptFiltersStr)
    console.log(resultValidate)

    let rptFilters = null
    if (resultValidate.Code === 200) {
      rptFilters = resultValidate.Message
    }

    /*
    // /CountersHistory/Dealers/IynvD8HtVhfHZBgc68aimLQQh693/Customers/-MNJDIIH6bzHQ2NP2tT-/2022/02/00-20-6B-3E-6D-50
    let fromPath = '/PrintersHistory/Dealers/' + historyFilters.dealer + '/Customers/' + custKey + '/' + dPath;
    let countersHistoryRef = dbStore.collection(path).where('LoggedInt', '>=', fromDate).where('LoggedInt', '<=', toDate)
    */

    if (rptFilters) {
      console.log(' - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -')
      console.log(' - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -')
      return GetReportByKey(rptFilters.ReportKey).then((result) => {
        console.log('RunReport > GetReportByKey result:')
        console.log(result)
        if (result && result.Code === 200) {
          let rpt = JSON.parse(result.Message)
          return LoadReportData(rpt).then((resultRptData) => {
            return Promise.resolve({ Code: 200, Message: 'Method = ' + rpt.Method })
          }).catch((err) => catchError(970, 'LoadReportData', err.message))
        } else {
          return Promise.resolve(result)
        }
      }).catch((err) => catchError(910, 'GetReportByKey', err.message))
    } else {
      return Promise.resolve({ Code: 902, Message: 'RunReport Error: rptFilters is NULL' })
    }
    // res.send({ Code: 200, Message: 'Success XML' })
  } catch (err1) {
    console.log('RunReport Error: ' + err1.message)
    return Promise.resolve({ Code: 901, Message: 'RunReport Error: ' + err1.message })
  }
}

function LoadReportData (report) {
  console.log('LoadReportData Started ...')
  if (report) {
    return db.ref('FastReports/' + reportKey).once('value').then(function (snapReportSettings) {
      console.log('GetReportByKey Success.. Load Data ...')
      var reportSettingsObj = snapReportSettings.val()
      if (reportSettingsObj) {
        let reportSettings = JSON.stringify(reportSettingsObj)
        return Promise.resolve({ Code: 200, Message: reportSettings })
      } else {
        console.log('Missin ReportKey in DB!')
        return Promise.resolve({ Code: 902, Message: 'Missin ReportKey in DB!' })
      }
    }).catch((err) => catchError(909, 'GetReportByKey', err.message))
  } else {
    console.log('Missin Parameter [report]')
    return Promise.resolve({ Code: 901, Message: 'Missing Parameter [report]!' })
  }
}

function ValidateParams (rptFiltersStr) {
  console.log('ValidateParams Started ...')
  try {
    if (!rptFiltersStr || rptFiltersStr.length === 0) {
      console.log('ValidateParams::: rptFiltersStr.length === 0')
      return ({ Code: 999, Message: 'ValidateParams: rptFilters query params are missing!' })
    } else {
      let rptFilters = JSON.parse(rptFiltersStr)
      console.log('ValidateParams::: JSON.parse(rptFiltersStr)')
      console.log(rptFilters)
      if (rptFilters) {
        let keys = Object.keys(rptFilters)
        console.log('ValidateParams::: object.keys(rptFilters)')
        console.log(keys)
        keys.forEach((k) => {
          if (!rptFilters[k] || rptFilters[k].length === 0) {
            return ({ Code: 997, Message: 'ValidateParams: ' + rptFilters[k] + ' param is missing!' })
          }
        })
        // If all checks passed, then return the object:
        console.log('ValidateParams Success.')
        return ({ Code: 200, Message: rptFilters })
      } else {
        return ({ Code: 998, Message: 'ValidateParams: rptFilters json params are missing!' })
      }
    }
  } catch (exp) {
    console.log('ValidateParams Error: ' + exp.message)
    return ({ Code: 996, Message: 'ValidateParams Error: ' + exp.message })
  }
}

function GetReportByKey (reportKey) {
  console.log('GetReportByKey Started ...')
  if (reportKey) {
    return db.ref('FastReports/' + reportKey).once('value').then(function (snapReportSettings) {
      console.log('GetReportByKey Success.. Load Data ...')
      var reportSettingsObj = snapReportSettings.val()
      if (reportSettingsObj) {
        let reportSettings = JSON.stringify(reportSettingsObj)
        return Promise.resolve({ Code: 200, Message: reportSettings })
      } else {
        console.log('Missin ReportKey in DB!')
        return Promise.resolve({ Code: 902, Message: 'Missin ReportKey in DB!' })
      }
    }).catch((err) => catchError(909, 'GetReportByKey', err.message))
  } else {
    console.log('Missin Parameter [ReportKey]')
    return Promise.resolve({ Code: 901, Message: 'Missing Parameter [ReportKey]!' })
  }
}

function catchError (code, func, msg) {
  let errMsg = '[' + func + '] >>> ' + msg
  console.log(func + ' Error (' + code + ') : ' + errMsg)
  return Promise.reject({ Code: 200, Message: errMsg })
}



// WEBPACK FOOTER //
// ./src/plugins/reportsDalTest.js